import { geo } from "./../../../api/geo.js";
import {
  getStores,
  getStoresSortByDisplayOrder,
} from "../../../api/services/storeService.js";
import {
  operatingHours,
  getCurrentDate,
  IsStoreOpenAtTime,
} from "../../../api/helpers/datetimeHelper.js";
import { mapMutations, mapActions, mapGetters } from "vuex";
import { isStoreSelectionAtCheckout } from "../../../api/helpers/commonHelpers";
export default {
  filters: {
    Capitalize: function(value) {
      return value.charAt(0).toUpperCase() + value.substr(1);
    },
  },

  computed: {
    ...mapGetters(["mobileStyles", "desktopStyles", "hqDoc"]),
    show() {
      return this.populars.length > 0;
    },
    getNoStoreAvailableInDatabaseLang() {
      return this.$t("message.noRestaurantIsAvailableInThisState");
    },
    activeStores() {
      return this.populars.filter(
        (p) => p.IsEnabled !== false && p.IsTest !== true
      );
    },
    orderedResturants() {
      let copy = [
        ...(this.activeState == "All"
          ? this.activeStores
          : this.activeStores.filter(
              (p) => p.Location.State == this.activeState
            )),
      ];
      let that = this;
      return copy.sort((a, b) => {
        let d1 = that.distance(a.Location.Latitude, a.Location.Longitude);
        let d2 = that.distance(b.Location.Latitude, b.Location.Longitude);
        return d1 - d2;
      }).sort((x, y) => {
        const xIsClosed = this.storeClosed(x),
          yIsClosed = this.storeClosed(y);
        return (xIsClosed === yIsClosed) ? 0 : xIsClosed ? 1 : -1;
      });
    },
    allowedState() {
      var result = this.states.filter((p) =>
        this.activeStores.some((s) => s.Location.State == p)
      );
      return [this.states[0], ...result];
    },
  },
  methods: {
    ...mapMutations(["setStoreLoaded"]),
    ...mapActions([
      "insertErrorlog",
      "redirectToErrorPage",
      "selectSubCompany",
      "getSelectedStoreMenu",
      "raiseAlert",
    ]),

    checkLocation() {
      try {
        let that = this;
        if (geo.support()) {
          geo.getPos((result) => {
            that.pos = {
              lat: result.coords.latitude,
              long: result.coords.longitude,
            };
          }, error => {
            this.insertErrorlog([
              error.message,
              JSON.stringify(error),
              this.$router.currentRoute.fullPath,
            ]);
          });
        }
      } catch (reason) {
        this.insertErrorlog([
          reason.name,
          reason.toString(),
          this.$router.currentRoute.fullPath,
        ]);
      }
    },
    distance(lat, long) {
      let res = 1;
      if (this.pos) {
        res = geo.distance(this.pos.lat, this.pos.long, lat, long, "K");
      }
      return res.toFixed(1);
    },
    getStores() {
      this.busy = true;
      let that = this;
      getStores()
        .get()
        .then(function(snapshot) {
          that.busy = false;
          that.setStoreLoaded();
          that.populars = [];
          snapshot.docs.forEach(function(doc) {
            let rs = doc.data();
            if (!rs.IsHQ) {
              that.populars.push(rs);
            } else {
              if (
                isStoreSelectionAtCheckout(rs) &&
                !that.$route.query.selectMode
              ) {
                that.navigateToStore(rs);
              }
            }
          });
        })
        .catch((reason) => {
          that.busy = false;
          that.insertErrorlog([
            reason.name,
            reason.toString(),
            that.$router.currentRoute.fullPath,
          ]);
          that.redirectToErrorPage();
        });
    },
    getnearStores() {
      this.busy = true;
      let xKilometer = 5;
      let that = this;
      getStoresSortByDisplayOrder()
        .get()
        .then(function(snapshot) {
          that.busy = false;
          snapshot.docs.forEach(function(doc) {
            let rs = doc.data();
            if (
              that.distance(rs.Location.Latitude, rs.Location.Longitude) <
              xKilometer
            ) {
              if (!rs.IsHQ) that.populars.push(rs);
            }
          });
        })
        .catch((reason) => {
          that.busy = false;
          that.insertErrorlog([
            reason.name,
            reason.toString(),
            that.$router.currentRoute.fullPath,
          ]);
          that.redirectToErrorPage();
        });
    },
    getOperatingHours(storedoc) {
      var now = getCurrentDate(storedoc.TimezoneCity);
      return operatingHours(storedoc.BlackoutDates, now, storedoc.OperatingHours);
    },
    navigateToGiftCardStore(rs) {
      this.$router.push({
        name: "giftstore",
        params: { storeid: rs.ID, storename: rs.Name },
      });
    },
    async navigateToStore(rs) {
      if (this.storeClosed(rs)) {
        this.raiseAlert({
          title: 'Oops!',
          body: this.$t("message.storeClosed"),
        });
        return;
      }
      let storeName = this.$route.query.selectMode ? this.hqDoc.Name : rs.Name;
      let storeNameEncoded = storeName;
      if (this.$route.query.selectMode) {
        await this.selectSubCompany(rs.ID);
        await this.getSelectedStoreMenu(rs.ID);
        var routeName = this.isMobile() ? "shoppingcartmobile" : "checkout";
        this.$router.push({
          name: routeName,
          params: {
            storeid: this.hqDoc.ID,
            storename: storeNameEncoded,
          },
        });
      } else {
        this.$router.push({
          name: "store",
          params: { storeid: rs.ID, storename: storeNameEncoded },
        });
      }
    },
    filterStore(stateName) {
      this.activeState = stateName;
      if (this.populars.length == 0) this.getStores();
    },
    storeClosed(rs) {
      var now = getCurrentDate(rs.TimezoneIanaFormat);
      var open = IsStoreOpenAtTime(rs.BlackoutDates, rs.OperatingHours, rs.IsInOperation, now);
      return (
        (!open &&
          !(rs.EnablePreoderForDelivery || rs.EnablePreoderForPickup)) ||
        !rs.IsInOperation
      );
    },
    getStyle() {
      var style = [];
      if (this.isMobile) {
        style.push(this.mobileStyles.CommonColorBackground);
        style.push(this.mobileStyles.primaryColor);
        style.push(this.mobileStyles.btn);
      } else {
        style.push(this.desktopStyles.CommonColorBackground);
        style.push(this.desktopStyles.primaryColor);
        style.push(this.desktopStyles.btn);
      }
      return style;
    },
  },
};
